var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12386_3294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12386_3294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 32.0004C86.1333 32.0004 88 32.8004 89.6 34.4004C91.2 36.0004 92 37.8671 92 40.0004V48.0004C92 48.4671 91.9333 48.9671 91.8 49.5004C91.6667 50.0337 91.5333 50.5337 91.4 51.0004L79.4 79.2004C78.8 80.5337 77.8 81.6671 76.4 82.6004C75 83.5337 73.5333 84.0004 72 84.0004H28V32.0004L52 8.20039C53 7.20039 54.1833 6.61706 55.55 6.45039C56.9167 6.28372 58.2333 6.53372 59.5 7.20039C60.7667 7.86706 61.7 8.80039 62.3 10.0004C62.9 11.2004 63.0333 12.4337 62.7 13.7004L58.2 32.0004H84ZM36 35.4004V76.0004H72L84 48.0004V40.0004H48L53.4 18.0004L36 35.4004ZM16 84.0004C13.8 84.0004 11.9167 83.2171 10.35 81.6504C8.78333 80.0837 8 78.2004 8 76.0004V40.0004C8 37.8004 8.78333 35.9171 10.35 34.3504C11.9167 32.7837 13.8 32.0004 16 32.0004H28V40.0004H16V76.0004H28V84.0004H16Z",
    fill: "#FDFDFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.a035e3d4b08ae24295031eacbae3e8a7.svg";
export { ForwardRef as ReactComponent };